import React from "react";
import SelectComponent from "react-select";
import AsyncSelect from "react-select/async";

export default function Select({
  options = [],
  label = "",
  labelClass = "text-sm font-semibold text-lightBlack",
  errorMessage,
  ...props // make sure this pops here is for input only
}) {
  const customStyles = {
    control: (styles) => {
      //console.log("stules", styles);
      return {
        ...styles,
        backgroundColor: "white",
        borderColor: errorMessage ? "red" : "#dfdfdf",
        height: 51,
        borderRadius: 6,
        minHeight: 51,
        boxShadow: "none",
        "&:hover": {
          border: "1px solid #2563eb !important",
        },
        paddingLeft: 8,
      };
    },
    option: (provided) => {
      return {
        ...provided,
        padding: "8px 18px",
      };
    },
  };

  const Inner = props.loadOptions ? AsyncSelect : SelectComponent;

  return (
    <div className="form-input-container">
      {label && (
        <label htmlFor={label} className={labelClass}>
          {label}
        </label>
      )}
      <Inner
        className={label && "mt-2"}
        options={options}
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
        }}
        cacheOptions={!!props.loadOptions}
        defaultOptions={props.defaultOptions || options}
        {...props}
      />
      {errorMessage && <p className="input-error-message mt-2 -mb-1">* {errorMessage}</p>}
    </div>
  );
}
